<ng-container [formGroup]="form">

    <div class="gup-C-searchBar">

        <kal-form-field class="without-label gup-O-search">

            <kal-input icon="search"
                       placeholder="Mot clé"
                       formControlName="searchbar">
            </kal-input>

        </kal-form-field>

        <kal-button class="gup-C-searchBar__filterBtn"
                    kalTheme="large"
                    (click)="toggleFilters()">
            <kal-icon><i class="material-icons">tune</i></kal-icon>
            <span>Filtrer</span>
        </kal-button>

    </div>


    <!-- template pour les filtres-->
    <ng-template #filtersTemplate>
        <app-folder-bank-filters formControlName="filters">
        </app-folder-bank-filters>
    </ng-template>

    <ng-template #listTemplate>

        <kal-list tabindex="1"
                  [icon]="null"
                  [dataSource]="foldersListDatasource"
                  (selectionChange)="selectFolder($event)"
                  [virtualScrollConfig]="{itemSize: 9}"
                  class="folderBankListDialog__list">

            <ng-template kalListItem let-item="item">
                <div class="gup-C-kalListContent">
                    <div class="gup-C-kalListContent__row">
                        <span class="gup-C-kalListContent__item">
                            <div>{{ item.Libelle }}</div>
                        </span>
                        <span [ngClass]="item.Statut.Code | statusClassGed"
                              class="gup-C-kalListContent__item gup-O-status">
                            {{ item.Statut.Libelle }}
                        </span>
                    </div>
                </div>
            </ng-template>

        </kal-list>

    </ng-template>

    <div [kalLoading]="loading">
        <ng-container *ngTemplateOutlet="isOpenedFilters ? filtersTemplate : listTemplate"></ng-container>
    </div>

</ng-container>
